// extracted by mini-css-extract-plugin
module.exports = {"labelText":"styles_labelText__WD_qC","helperText":"styles_helperText__1o4MH"};